// Mapeamento de palavras-chave por óleo para cruzamento com texto livre
export const PALAVRAS_CHAVE_OLEOS: Record<string, string[]> = {
  'Lavanda': ['sono', 'insônia', 'insonia', 'acordar à noite', 'acordar a noite', 'ansiedade', 'nervoso', 'estresse', 'stress', 'pressão alta', 'tensão', 'agitação', 'agitacao', 'relaxar', 'descanso', 'cansaço mental', 'cansaco mental', 'dormir', 'noite', 'relaxamento'],
  'Hortelã-Pimenta': ['energia', 'foco', 'concentração', 'concentracao', 'disposição', 'disposicao', 'cansaço', 'cansaco', 'produtividade', 'enxaqueca', 'dor de cabeça', 'dor de cabeca', 'clareza', 'ânimo', 'animo', 'motivação', 'motivacao', 'disciplina', 'determinação', 'determinacao', 'força de vontade', 'forca de vontade', 'acordar cansada', 'acordar cansado', 'sem energia'],
  'Limão Siciliano': ['detox', 'inchaço', 'inchaco', 'peso', 'limpeza', 'clareza mental', 'raciocínio', 'raciocinio', 'leveza', 'digestão', 'digestao', 'imunidade', 'fígado', 'figado', 'desintoxicar', 'colesterol', 'pressão', 'pressao', 'circulação', 'circulacao'],
  'Olíbano': ['memória', 'memoria', 'esquecimento', 'propósito', 'proposito', 'autoconhecimento', 'espiritualidade', 'meditação', 'meditacao', 'clareza interior', 'conexão', 'conexao', 'inflamação', 'inflamacao', 'imunidade', 'células', 'celulas', 'renovação', 'renovacao', 'esquecendo', 'diabetes', 'colesterol', 'pele', 'envelhecimento'],
  'Copaíba': ['dor crônica', 'dor cronica', 'dores articulares', 'dores musculares', 'inflamação', 'inflamacao', 'inflamação crônica', 'inflamacao cronica', 'inflamatório', 'inflamatorio', 'articulação', 'articulacao', 'sistema nervoso', 'ansiedade crônica', 'ansiedade cronica', 'depressão', 'depressao', 'proteção celular', 'protecao celular', 'imunidade', 'estresse', 'stress', 'pele', 'diabetes', 'colesterol', 'glicemia', 'pressão alta', 'pressao alta', 'hipertensão', 'hipertensao'],
  'Tangerina': ['alegria', 'tristeza', 'leveza', 'humor', 'nervosismo', 'ansiedade', 'sono', 'digestão', 'digestao', 'imunidade', 'irritabilidade', 'irritada', 'irritado', 'triste', 'desânimo', 'desanimo', 'colesterol', 'fígado', 'figado', 'diabetes'],
  'Mix para Aterramento - Balance': ['ansiedade', 'medo', 'raiva', 'estagnação', 'estagnacao', 'equilíbrio', 'equilibrio', 'nervoso', 'trauma', 'luto', 'convulsão', 'convulsao', 'epilepsia', 'hiperatividade', 'tdah', 'meditação', 'meditacao', 'aterramento', 'segurança', 'seguranca', 'propósito', 'proposito', 'direção', 'direcao', 'identidade', 'travada', 'travado', 'presa', 'preso', 'pressão alta', 'pressao alta', 'hipertensão', 'hipertensao'],
  'Mix de Proteção - On Guard': ['imunidade', 'gripe', 'resfriado', 'vírus', 'virus', 'infecção', 'infeccao', 'proteção', 'protecao', 'energia vital', 'apatia', 'vergonha', 'fadiga', 'cansaço', 'cansaco', 'fraqueza'],
  'Mix Respiratório - Breathe': ['respiração', 'respiracao', 'sinusite', 'rinite', 'asma', 'tosse', 'congestão', 'congestao', 'tristeza', 'orgulho', 'coração', 'coracao', 'emoção', 'emocao', 'pulmão', 'pulmao', 'ansiedade', 'nariz', 'alergia'],
  'Mix Calmante - Deep Blue': ['dor muscular', 'tensão', 'tensao', 'inflamação', 'inflamacao', 'articulação', 'articulacao', 'lesão', 'lesao', 'treino', 'pescoço', 'pescoco', 'ombro', 'lombar', 'hematoma', 'dor nas costas', 'coluna', 'dores no corpo', 'dor no corpo'],
  'Mix Digestivo - Zengest': ['intestino', 'digestão', 'digestao', 'gases', 'azia', 'refluxo', 'constipação', 'constipacao', 'diarreia', 'diarréia', 'cólica', 'colica', 'inchaço', 'inchaco', 'náusea', 'nausea', 'intolerância', 'intolerancia', 'barriga', 'estômago', 'estomago'],
  'Mix Metabólico - Meta PWR': ['peso', 'metabolismo', 'emagrecimento', 'emagrecer', 'compulsão alimentar', 'compulsao alimentar', 'ansiedade por comida', 'energia', 'disposição', 'disposicao', 'gordura', 'dieta', 'engordar'],
  'Mix Mensal Feminino - ClaryCalm': ['tpm', 'cólica', 'colica', 'menopausa', 'hormônio', 'hormonio', 'ciclo', 'endometriose', 'irritabilidade', 'humor', 'ansiedade feminina', 'menstruação', 'menstruacao', 'período', 'periodo'],
  'Melaleuca': ['pele', 'acne', 'fungo', 'infecção', 'infeccao', 'ferida', 'caspa', 'imunidade', 'bactéria', 'bacteria', 'vírus', 'virus', 'espinha', 'micose'],
}

// Lista de termos de saúde para identificar sintomas não mapeados
const TERMOS_SAUDE_COMUNS = [
  'diabetes', 'diabete', 'diabético', 'diabética',
  'colesterol', 'triglicerides', 'triglicerídeos',
  'pressão', 'pressao', 'hipertensão', 'hipertensao', 'hipertenso', 'hipertensa',
  'obesidade', 'sobrepeso', 'emagrecer', 'emagrecimento',
  'câncer', 'cancer', 'tumor', 'células cancerígenas',
  'tireoide', 'tireóide', 'hipotireoidismo', 'hipertireoidismo',
  'depressão', 'depressao', 'deprimida', 'deprimido',
  'ansiedade', 'ansiosa', 'ansioso', 'pânico', 'panico',
  'síndrome', 'sindrome', 'doença', 'doenca',
  'artrite', 'artrose', 'reumatismo',
  'fibromialgia', 'enxaqueca', 'migraine',
  'insônia', 'insonia', 'dormir', 'sono',
  'gastrite', 'úlcera', 'ulcera', 'refluxo',
  'alérgica', 'alergica', 'alérgico', 'alergico', 'alergia',
  'autoimune', 'imunológica', 'imunologica',
  'hormonal', 'hormônio', 'hormonio', 'menopausa',
  'circulação', 'circulacao', 'varizes',
  'osteoporose', 'ossos', 'ósseo', 'osseo',
  'renal', 'rins', 'rim',
  'hepática', 'hepatica', 'fígado', 'figado',
  'intestinal', 'intestino', 'constipação', 'constipacao',
  'pele', 'dérmica', 'dermica', 'dermatite',
  'cardíaca', 'cardiaca', 'coração', 'coracao',
  'pulmonar', 'pulmão', 'pulmao', 'respiração', 'respiracao',
  'neuronal', 'neural', 'nervos', 'nervo',
  'inflamatório', 'inflamatorio', 'inflamação', 'inflamacao',
  'dor', 'dores', 'dolorosa', 'doloroso',
  'fadiga', 'cansaço', 'cansaco', 'exaustão', 'exaustao',
  'estresse', 'stress', 'estressada', 'estressado',
  'memória', 'memoria', 'esquecimento', 'cognitiva', 'cognitivo',
  'concentração', 'concentracao', 'foco', 'atenção', 'atencao',
]

// Conversão dos nomes de óleos do diagnóstico para os nomes com nome comercial
const MAPA_NOMES_OLEOS: Record<string, string> = {
  'Mix para Estabilidade': 'Mix para Aterramento - Balance',
  'Mix para Aterramento': 'Mix para Aterramento - Balance',
  'Mix Imunidade': 'Mix de Proteção - On Guard',
  'Mix Respiratório': 'Mix Respiratório - Breathe',
  'Mix para Tensão e Dores': 'Mix Calmante - Deep Blue',
  'Mix Digestivo': 'Mix Digestivo - Zengest',
  'Mix Metabólico': 'Mix Metabólico - Meta PWR',
  'Mix Mensal Feminino': 'Mix Mensal Feminino - ClaryCalm',
}

// Labels curtos para sintomas (usados na justificativa)
const LABELS_SINTOMAS: Record<string, string> = {
  'sono': 'sono',
  'disposicao': 'disposição, energia',
  'foco': 'foco, concentração',
  'memoria': 'memória, esquecimento',
  'ansiedade': 'ansiedade, mente acelerada',
  'peso': 'peso, compulsão alimentar',
  'dores': 'dores recorrentes, tensão',
  'medicamentos': 'uso de medicamentos, inflamação',
  'inflamacoes': 'inflamações, alergias',
  'intestino': 'intestino irregular',
  'vergonha': 'vergonha, medo do julgamento',
  'culpa': 'culpa, sobrecarga emocional',
  'apatia': 'apatia, desânimo',
  'tristeza': 'tristeza, lembranças dolorosas',
  'medo': 'medo, resistência a mudanças',
  'escassez': 'escassez, comparação',
  'raiva': 'raiva, irritabilidade',
  'orgulho': 'orgulho, dificuldade em pedir ajuda',
  'estagnacao': 'estagnação, ciclos repetitivos',
  'desequilibrio': 'desequilíbrio emocional',
}

// Mapeamento de pergunta → óleos indicados (espelhando diagnostico.ts)
const PERGUNTAS_OLEOS: Record<string, string[]> = {
  'sono': ['Lavanda'],
  'disposicao': ['Hortelã-Pimenta'],
  'foco': ['Limão Siciliano', 'Hortelã-Pimenta'],
  'memoria': ['Olíbano'],
  'ansiedade': ['Mix para Estabilidade', 'Copaíba', 'Tangerina'],
  'peso': ['Mix Metabólico', 'Tangerina', 'Limão Siciliano'],
  'dores': ['Hortelã-Pimenta', 'Mix para Tensão e Dores', 'Copaíba'],
  'medicamentos': ['Copaíba', 'Olíbano', 'Mix para Estabilidade'],
  'inflamacoes': ['Copaíba', 'Olíbano'],
  'intestino': ['Mix Digestivo'],
  'vergonha': ['Copaíba', 'Mix Imunidade'],
  'culpa': ['Copaíba', 'Limão Siciliano', 'Hortelã-Pimenta'],
  'apatia': ['Mix Imunidade', 'Tangerina'],
  'tristeza': ['Mix Respiratório', 'Tangerina', 'Hortelã-Pimenta'],
  'medo': ['Mix para Estabilidade', 'Lavanda', 'Hortelã-Pimenta'],
  'escassez': ['Mix para Estabilidade', 'Tangerina', 'Limão Siciliano'],
  'raiva': ['Mix para Estabilidade'],
  'orgulho': ['Mix Respiratório', 'Hortelã-Pimenta'],
  'estagnacao': ['Mix para Estabilidade', 'Mix Imunidade', 'Hortelã-Pimenta'],
  'desequilibrio': ['Mix para Estabilidade', 'Copaíba', 'Olíbano', 'Hortelã-Pimenta', 'Tangerina'],
}

// Converte nome do óleo do diagnóstico para nome comercial
export function nomeComercial(nomeOleo: string): string {
  return MAPA_NOMES_OLEOS[nomeOleo] || nomeOleo
}

// BLOCO 1: Protocolo Completo — cruza óleos indicados com sintomas SIM
export function gerarProtocoloCompleto(lead: any): { oleo: string; justificativas: string[] }[] {
  const oleosIndicados: string[] = lead.oleos_indicados || []
  const respostas: Record<string, boolean> = lead.respostas || {}

  // Para cada óleo indicado, encontrar quais sintomas SIM o justificam
  const protocolo: { oleo: string; justificativas: string[] }[] = []

  oleosIndicados.forEach(oleo => {
    const justificativas: string[] = []

    // Percorrer as respostas SIM e verificar se esse óleo está associado
    Object.entries(respostas).forEach(([perguntaId, valor]) => {
      if (!valor) return // Só interessa SIM
      const oleosAssociados = PERGUNTAS_OLEOS[perguntaId] || []
      if (oleosAssociados.includes(oleo)) {
        const label = LABELS_SINTOMAS[perguntaId]
        if (label) justificativas.push(label)
      }
    })

    // Se não encontrou justificativa direta, usar o benefício genérico
    if (justificativas.length === 0) {
      // Pode ter sido adicionado por condição de saúde
      justificativas.push('indicado pela condição de saúde')
    }

    protocolo.push({
      oleo: nomeComercial(oleo),
      justificativas: [...new Set(justificativas)], // remover duplicatas
    })
  })

  return protocolo
}

// Função auxiliar para verificar palavra-chave completa (não substring)
function contemPalavraChave(texto: string, palavraChave: string): boolean {
  const regex = new RegExp(`\\b${palavraChave}\\b`, 'i')
  return regex.test(texto)
}

// ══════════════════════════════════════════════════════════════
// MAPEAMENTO DE PRIORIDADES PARA ÓLEOS (novo sistema estruturado)
// ══════════════════════════════════════════════════════════════

export const PRIORIDADES_OLEOS: Record<string, string[]> = {
  'Sono e descanso': ['Lavanda', 'Tangerina'],
  'Energia e disposição': ['Hortelã-Pimenta', 'Mix Metabólico - Meta PWR'],
  'Foco e memória': ['Limão Siciliano', 'Hortelã-Pimenta', 'Olíbano'],
  'Dores e inflamações': ['Copaíba', 'Olíbano', 'Mix Calmante - Deep Blue'],
  'Digestão e intestino': ['Mix Digestivo - Zengest'],
  'Peso e metabolismo': ['Mix Metabólico - Meta PWR', 'Tangerina', 'Limão Siciliano'],
  'Imunidade e proteção': ['Mix de Proteção - On Guard', 'Melaleuca', 'Olíbano'],
  'Saúde respiratória': ['Mix Respiratório - Breathe'],
  'Saúde da pele': ['Melaleuca', 'Lavanda', 'Copaíba'],
  'Ansiedade e estresse': ['Mix para Aterramento - Balance', 'Copaíba', 'Lavanda'],
  'Tristeza e apatia': ['Mix Respiratório - Breathe', 'Tangerina', 'Mix de Proteção - On Guard'],
  'Medo e insegurança': ['Mix para Aterramento - Balance', 'Lavanda'],
  'Raiva e irritabilidade': ['Mix para Aterramento - Balance'],
  'Estagnação e bloqueios': ['Mix para Aterramento - Balance', 'Mix de Proteção - On Guard', 'Hortelã-Pimenta'],
  'Autoestima e merecimento': ['Copaíba', 'Limão Siciliano', 'Tangerina'],
  'Equilíbrio emocional geral': ['Mix para Aterramento - Balance', 'Copaíba', 'Olíbano', 'Tangerina'],
}

// Desconfortos que cada óleo resolve por prioridade (para o Protocolo Prioritário)
const OLEO_DESCONFORTOS_POR_PRIORIDADE: Record<string, Record<string, string>> = {
  'Lavanda': {
    'Sono e descanso': 'sono reparador e descanso',
    'Ansiedade e estresse': 'ansiedade e estresse',
    'Medo e insegurança': 'medo e insegurança',
    'Saúde da pele': 'pele sensível e relaxamento',
  },
  'Tangerina': {
    'Sono e descanso': 'leveza e sono tranquilo',
    'Energia e disposição': 'alegria e disposição',
    'Peso e metabolismo': 'metabolismo e digestão',
    'Tristeza e apatia': 'tristeza e apatia',
    'Autoestima e merecimento': 'leveza e autoestima',
    'Equilíbrio emocional geral': 'equilíbrio emocional',
  },
  'Hortelã-Pimenta': {
    'Energia e disposição': 'energia e disposição',
    'Foco e memória': 'foco e concentração',
    'Estagnação e bloqueios': 'bloqueios e motivação',
  },
  'Mix Metabólico - Meta PWR': {
    'Energia e disposição': 'metabolismo e energia',
    'Peso e metabolismo': 'peso, metabolismo e controle de apetite',
  },
  'Limão Siciliano': {
    'Foco e memória': 'clareza mental e foco',
    'Peso e metabolismo': 'detox e metabolismo',
    'Autoestima e merecimento': 'clareza e leveza mental',
  },
  'Olíbano': {
    'Foco e memória': 'memória e clareza mental',
    'Dores e inflamações': 'inflamação e proteção celular',
    'Imunidade e proteção': 'imunidade e inflamação',
    'Equilíbrio emocional geral': 'equilíbrio emocional profundo',
  },
  'Copaíba': {
    'Dores e inflamações': 'dores crônicas e inflamação',
    'Imunidade e proteção': 'proteção e inflamação',
    'Saúde da pele': 'pele e proteção celular',
    'Ansiedade e estresse': 'sistema nervoso e ansiedade',
    'Autoestima e merecimento': 'sistema nervoso e autoestima',
    'Equilíbrio emocional geral': 'equilíbrio emocional e inflamação',
  },
  'Mix Calmante - Deep Blue': {
    'Dores e inflamações': 'dores musculares, tensão e inflamações',
  },
  'Mix Digestivo - Zengest': {
    'Digestão e intestino': 'digestão, intestino e bem-estar digestivo',
  },
  'Mix de Proteção - On Guard': {
    'Imunidade e proteção': 'imunidade e proteção',
    'Tristeza e apatia': 'energia vital e motivação',
    'Estagnação e bloqueios': 'energia e motivação',
  },
  'Melaleuca': {
    'Imunidade e proteção': 'imunidade e proteção',
    'Saúde da pele': 'pele sensível e acne',
  },
  'Mix Respiratório - Breathe': {
    'Saúde respiratória': 'saúde respiratória e vias aéreas',
    'Tristeza e apatia': 'tristeza e abertura emocional',
  },
  'Mix para Aterramento - Balance': {
    'Ansiedade e estresse': 'ansiedade e estresse',
    'Medo e insegurança': 'medo e insegurança',
    'Raiva e irritabilidade': 'raiva e irritabilidade',
    'Estagnação e bloqueios': 'estagnação e bloqueios emocionais',
    'Equilíbrio emocional geral': 'equilíbrio emocional e aterramento',
  },
}

// BLOCO 2B: Protocolo Prioritário baseado nas prioridades selecionadas (novo)
export function gerarProtocoloPrioritarioPorPrioridades(
  prioridades: string[]
): { oleo: string; desconfortos: string }[] {
  if (!prioridades || prioridades.length === 0) return []

  // Coletar óleos relevantes para as prioridades selecionadas (sem duplicatas)
  const oleosMap = new Map<string, Set<string>>()

  prioridades.forEach(prioridade => {
    const oleos = PRIORIDADES_OLEOS[prioridade] || []
    oleos.forEach(oleo => {
      if (!oleosMap.has(oleo)) oleosMap.set(oleo, new Set())
      const desconforto =
        OLEO_DESCONFORTOS_POR_PRIORIDADE[oleo]?.[prioridade] || prioridade.toLowerCase()
      oleosMap.get(oleo)!.add(desconforto)
    })
  })

  return Array.from(oleosMap.entries()).map(([oleo, desconfortosSet]) => ({
    oleo,
    desconfortos: Array.from(desconfortosSet).join(', '),
  }))
}

// BLOCO 2: Protocolo Prioritário — cruza texto livre com palavras-chave
export function gerarProtocoloPrioritario(lead: any): { oleo: string | null; palavrasEncontradas: string[] }[] {
  const textoLivre: string = (lead.objetivo_saude || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  if (!textoLivre.trim()) return []

  const resultados: { oleo: string; palavrasEncontradas: string[]; score: number }[] = []
  const palavrasCapturadas = new Set<string>()

  // 1. Identificar óleos com palavras-chave correspondentes
  Object.entries(PALAVRAS_CHAVE_OLEOS).forEach(([oleo, palavras]) => {
    const encontradas: string[] = []
    const encontradasNormalizadas = new Set<string>()

    palavras.forEach(palavra => {
      const palavraNorm = palavra.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      // Usar correspondência de palavra inteira ao invés de substring
      if (contemPalavraChave(textoLivre, palavraNorm) && !encontradasNormalizadas.has(palavraNorm)) {
        // Usar a versão original (com acento) para exibição
        encontradas.push(palavra)
        encontradasNormalizadas.add(palavraNorm)
        palavrasCapturadas.add(palavraNorm)
      }
    })

    if (encontradas.length > 0) {
      resultados.push({
        oleo,
        palavrasEncontradas: encontradas,
        score: encontradas.length,
      })
    }
  })

  // Ordenar por relevância (mais palavras encontradas primeiro)
  resultados.sort((a, b) => b.score - a.score)

  // 2. Identificar termos de saúde que NÃO foram mapeados para nenhum óleo
  const termosNaoMapeados: string[] = []
  
  TERMOS_SAUDE_COMUNS.forEach(termo => {
    const termoNorm = termo.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    
    // Se o termo aparece no texto mas não foi capturado por nenhum óleo
    if (contemPalavraChave(textoLivre, termoNorm) && !palavrasCapturadas.has(termoNorm)) {
      termosNaoMapeados.push(termo)
    }
  })

  // Converter resultados para o formato de retorno
  const protocolo: { oleo: string | null; palavrasEncontradas: string[] }[] = resultados.map(r => ({
    oleo: r.oleo,
    palavrasEncontradas: r.palavrasEncontradas,
  }))

  // Adicionar termos não mapeados ao final
  if (termosNaoMapeados.length > 0) {
    protocolo.push({
      oleo: null, // null indica que não há óleo específico
      palavrasEncontradas: termosNaoMapeados,
    })
  }

  return protocolo
}

// BLOCO 3: Mensagem pronta para WhatsApp
export function gerarMensagemPrescricao(lead: any): string {
  const nome = lead.nome?.split(' ')[0] || lead.nome || ''
  const protocoloCompleto = gerarProtocoloCompleto(lead)
  const protocoloPrioritario = gerarProtocoloPrioritario(lead)
  const objetivoSaude = lead.objetivo_saude || ''

  let msg = `Olá, ${nome}! 🌿\n\nCom base no seu diagnóstico, identifiquei os óleos essenciais ideais para você:\n\n*Seu protocolo completo:*\n\n`

  protocoloCompleto.forEach((item, idx) => {
    // Nome do óleo em negrito
    msg += `*${item.oleo}*\n`
    // Indicações na linha seguinte sem negrito
    msg += `${item.justificativas.join(', ')}.\n`
    // Linha em branco entre cada óleo (exceto no último)
    if (idx < protocoloCompleto.length - 1) {
      msg += `\n`
    }
  })

  // Usar prioridades estruturadas se disponíveis; fallback para texto livre
  const prioridades: string[] = lead.prioridades || lead.prioridades_saude || []
  if (prioridades.length > 0) {
    msg += `\n\n🎯 *Protocolo Prioritário — baseado nas suas prioridades:*\n`
    prioridades.forEach(p => { msg += `✅ ${p}\n` })
    msg += `\n*Óleos mais indicados:*\n\n`
    const resultados = gerarProtocoloPrioritarioPorPrioridades(prioridades)
    resultados.forEach((item: { oleo: string; desconfortos: string }, idx: number) => {
      msg += `*★ ${item.oleo}* → ${item.desconfortos}.\n`
      if (idx < resultados.length - 1) msg += `\n`
    })
  } else if (protocoloPrioritario.length > 0 && objetivoSaude.trim()) {
    msg += `\n\n🎯 *Para o que você mais quer resolver — ${objetivoSaude}:*\n\n`

    protocoloPrioritario.forEach((item, idx) => {
      if (item.oleo) {
        msg += `*${item.oleo}*\n`
        msg += `${item.palavrasEncontradas.join(', ')}.\n`
      } else {
        item.palavrasEncontradas.forEach((termo, termoIdx) => {
          msg += `*${termo.charAt(0).toUpperCase() + termo.slice(1)}*\n`
          msg += `(Avaliação e orientação no dia do atendimento).\n`
          if (termoIdx < item.palavrasEncontradas.length - 1) msg += `\n`
        })
      }
      if (idx < protocoloPrioritario.length - 1) msg += `\n`
    })
  }

  msg += `\n\nNa nossa conversa vou te explicar como usar cada um, as dosagens certas e como montar sua rotina. Te vejo em breve! 💚`

  return msg
}
